/**
 * Created by Sahan on 6/4/2018.
 */
const axios = require('axios');
const commonHelpers = require('./commonHelpers');
const config = commonHelpers.getConfig();
const baseURL = `${config.API.BASE_URL}/${config.API.API_PREFIX}/${config.API.VERSION}/`;

let reqHeader = {};
// if (commonHelpers.loggedUser) {
//   reqHeader.Authorization = `Bearer ${commonHelpers.loggedUser.authentication}`;
// }

const httpHelper = {
  post: (httpUrl, data, headers) => {
    let ajaxPromise = axios({
      url: baseURL+httpUrl,
      method: 'POST',
      data: data,
      headers: headers,
    });

    ajaxPromise.catch(error => {
      if(error.response){
        switch (error.response.status){
          case 401:
            commonHelpers.doLogout();
            break;
          case 403:
            commonHelpers.makeForbidden();
            break;
        }
      }
      });


    return ajaxPromise;
  },
  get: (httpUrl, headers) => {
    let ajaxPromise = axios({
      url: baseURL+httpUrl,
      method: 'GET',
      headers: headers,
    });

    ajaxPromise.catch(error => {
      if(error.response){
        switch (error.response.status){
          case 401:
            commonHelpers.doLogout();
            break;
          case 403:
            commonHelpers.makeForbidden();
            break;
        }
      }
    });

    return ajaxPromise;
  }
};

module.exports = httpHelper;



// WEBPACK FOOTER //
// ./src/libs/helpers/httpHelpers.js